/* projects/shared/src/lib/components/idba-lookup-autocomplete/idba-lookup-autocomplete.component.scss */
:host {
  display: block;
  width: 100%;
}
.idba-lookup-autocomplete {
  width: 100%;
}
/*# sourceMappingURL=idba-lookup-autocomplete.component.css.map */
